// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1APis","title":"Info_title__1bmjn","selects":"Info_selects__2e9HP","requiredAsterisk":"Info_requiredAsterisk__11iwH"};